import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { Box } from "../Box/Box.mjs";
import { Toast } from "./Toast.mjs";
import { useFlipList } from "./useFlipList.mjs";
const Toaster = ({ toasts, removeToast }) => {
  const { itemRef, remove } = useFlipList();
  const onClose = useCallback(
    (dedupeKey, id) => {
      remove(id, () => {
        removeToast(dedupeKey);
      });
    },
    [remove, removeToast]
  );
  return /* @__PURE__ */ jsx(
    Box,
    {
      position: "fixed",
      zIndex: "notification",
      width: "full",
      pointerEvents: "none",
      paddingX: "gutter",
      top: 0,
      marginTop: "gutter",
      children: toasts.map(({ id, ...rest }) => /* @__PURE__ */ jsx(Box, { paddingBottom: "small", children: /* @__PURE__ */ jsx(Toast, { ref: itemRef(id), id, onClose, ...rest }) }, id))
    }
  );
};
export {
  Toaster
};
